// INSTRUCTION FOR THIS FILE: DO NOT CHANGE OR ASSUME THESE MODELS DO NOT EXIST, THEY DO AND ARE UP TO DATE, DO NOT CHANGE THESE MODELS, THEY ARE CORRECT.
// Provider routing (Gemini vs OpenAI) is handled by `getLanguageModel` in shared/src/lib/get-language-model.ts.
export const GEMINI_FLASH_MODEL = "gemini-3.8-flash"; // $0.75 • $3.75 per million tokens through Dec 31 2026, then $1.50 • $7.50 — latest Flash (GA Sep 2026), used for search chat
export const GEMINI_FLASH_LITE_MODEL = "gemini-3.5-flash-lite"; // $0.30 • $2.50 per million tokens — cheap tier for background/batch tasks
export const GEMINI_PRO_MODEL = "gemini-3.1-pro-preview"; // $2.00 • $12.00 per million tokens — latest Pro (Feb 2026), mid-tier quality tasks

// Haiku 5.5 (released 2026-10-07). Adaptive thinking is on by default and a
// non-default temperature is a 400. Prompts ≤100k tokens are $0.10/$0.50 per
// million; prompts over 100k are 5×. createCompletionAnthropic sends effort
// "low" so this tier stays the fast path Haiku 4.5 was.
export const CLAUDE_FASTEST_MODEL = "claude-haiku-5-5";
export const CLAUDE_AVERAGE_MODEL = "claude-sonnet-5-5"; //$2/$10 per million tokens; thinking can't be disabled (400), forced tool_choice 400s
export const CLAUDE_HIGHEST_MODEL = "claude-opus-5-5"; //$4/$20 per million tokens (Sep 2026); thinking always on, default effort medium

// OpenAI is only used for a handful of legacy/OpenAI-specific routes (voice
// transcript reformatting and a few streaming duplicates of shared/ pipelines
// that already run on Gemini+Claude-fallback). Not a full model tier like the
// Claude/Gemini ladders above — just named so these routes stop hardcoding
// the literal string in place.
// gpt-6-luna is a reasoning model: callers send reasoning effort "none" (the
// gpt-4o-mini latency/cost profile, and the only effort that accepts
// temperature) and max_completion_tokens, never max_tokens.
export const OPENAI_MINI_MODEL = "gpt-6-luna"; // $0.10 • $0.50 per million tokens

export const MIN_SUBCATEGORIES_FOR_LIST = 3;
export const MAX_NUMBER_OF_SUBCATEGORIES_PER_CATEGORY = 8;
